import { FETCH_PRODUCT_SUCCESS } from 'Catalog/Product/ducks'

export default (state = {}, action) => {
  switch (action.type) {
    case 'LOAD_PRODUCT_DETAIL':
      return {
        ...state,
        [action.productSkuId]: {
          isLoading: true,
          availability: null,
          hasPriceUpdated: false
        }
      }
    case 'LOAD_PRODUCT_DETAIL_SUCCESS':
    case FETCH_PRODUCT_SUCCESS:
      return {
        ...state,
        [action.meta.previousAction.sku]: {
          isLoading: false,
          availability: null,
          hasPriceUpdated: false,
          ...action.payload.data
        }
      }
    case 'LOAD_PRODUCT_DETAIL_ERROR':
      return {
        ...state,
        [action.meta.previousAction.productSkuId]: {
          isLoading: false,
          availability: null,
          hasPriceUpdated: false,
          ...action.payload.error
        }
      }
    case 'FETCH_PRODUCT_NEW_AVAILABILITY':
      return {
        ...state,
        [action.productSkuId]: {
          isLoading: true,
          availability: null,
          hasPriceUpdated: false
        }
      }
    case 'FETCH_PRODUCT_NEW_AVAILABILITY_SUCCESS':
      const availability = action.payload.data[0]

      const {
        meta: {
          previousAction: { sku }
        }
      } = action

      state[sku].availability = { ...availability }
      state[sku].hasPriceUpdated = true

      return {
        ...state
      }
    case 'FETCH_PRODUCT_NEW_AVAILABILITY_FAIL':
      const {
        meta: {
          previousAction: {
            sku: productSkuId
          }
        }
      } = action

      state[productSkuId].error = action.error
      state[productSkuId].hasPriceUpdated = true
      state[productSkuId].isLoading = false
      state[productSkuId].availability = null
      state[productSkuId].hasPriceUpdated = false

      return {
        ...state
      }

    default:
      return { ...state }
  }
}

export const getPayment = (state, productSkuId) => {
  const { isPriceUpdated, price: { pointsCash: newPointCash } = {} } =
    state.availability[productSkuId] || { }

  if (!isPriceUpdated) return { isVisible: false }

  const {
    catalog: {
      currencyConfiguration: { pointsName }
    },
    payment: { isLoading, brands }
  } = state

  const isVisible =
    !!(newPointCash && newPointCash['installments'].length > 0)

  const description =
    isVisible && newPointCash['installments'][0].description

  const pointsCash = {
    currencyName: pointsName,
    points: newPointCash ? newPointCash.partialPoints : 0,
    description
  }

  const Cardbrands = { isLoading, brands }

  return {
    isVisible,
    pointsCash,
    Cardbrands
  }
}

export const getSkuImages = productSku =>
  productSku.images.map(image => ({
    original: image.largeImage || image.mediumImage,
    thumbnail: image.smallImage
  }))

export const getSkuProperties = productBySku =>
  productBySku.features.filter(feat => feat.type === 'CARACTERÍSTICAS')

export const getSkuSpecs = productBySku =>
  productBySku.features.filter(feat => feat.type === 'ESPECIFICAÇÕES TÉCNICAS')

export const getProductBySku = (state, productSkuId) => {
  const productBySku = state.productsBySku[productSkuId]

  if (!productBySku || productBySku.isLoading) return null

  const productSku = productBySku.skus.filter(
    ({ sku }) => sku === productSkuId
  )[0]

  const isVoucher = productBySku.vendor.type === 'EXTERNALVOUCHERVIRTUAL'

  const isPhysicalVoucher = productBySku.vendor.type === 'PHYSICALVOUCHER'

  const skuFeatures = productBySku.skus
    .map(({ sku, skuFeatures }) =>
      skuFeatures.map(feature => ({
        sku,
        ...feature
      }))
    )
    .reduce((acc, curr) => [...acc, ...curr], [])

  // let originalId

  // productBySku.skus.map(product => {
  //   if (product.sku === productSkuId) {
  //     originalId = product.originalId
  //   }
  // })

  const skuType = []

  skuFeatures.forEach(element => {
    const index = skuType.findIndex(x => x.sku === element.sku)

    if (index === -1) {
      skuType.push({
        sku: element.sku,
        currentSku: element.sku === productSkuId
      })
    }
  })

  skuFeatures.forEach(element => {
    const index = skuType.findIndex(x => x.sku === element.sku)

    if (index !== -1) {
      skuType[index][element.type] = element.value
    }
  })

  const composeSkuFeaturesByType = skuFeatures.reduce((acc, curr, idx) => {
    return {
      ...acc,
      [curr.type]: [
        ...(acc[curr.type] || {}),
        { sku: curr.sku, value: curr.value }
      ]
    }
  }, {})

  const skuFeaturesByType = Object.keys(composeSkuFeaturesByType).reduce(
    (acc, curr) => {
      return {
        ...acc,
        [curr]: composeSkuFeaturesByType[curr].reduce((acc, curr) => {
          return {
            ...acc,
            [curr.value]: [
              ...(acc[curr.value] || {}),
              {
                sku: curr.sku,
                currentSku: curr.sku === productSkuId
              }
            ]
          }
        }, {})
      }
    },
    {}
  )

  // const availability = productBySku.hasPriceUpdated
  //   ? productBySku.availability
  //   : {
  //     sku: productSku.sku,
  //     originalId: originalId,
  //     vendorId: productBySku.vendor.id
  //   }

  // const payment = getPayment(state, productSkuId)

  const itemCart = isVoucher
    ? {
      sku: productSku.sku,
      vendorId: productBySku.vendor.id,
      email:
          state &&
          state.oidc &&
          state.oidc.user &&
          state.oidc.user.profile &&
          state.oidc.user.profile.email
    }
    : {
      sku: productSku.sku,
      vendorId: productBySku.vendor.id
    }

  return {
    productId: productBySku.id,
    brandName: productBySku.brand ? productBySku.brand.name : '',
    productName: productBySku.name,
    isLoading: false,
    images: getSkuImages(productSku),
    isVoucher,
    isPhysicalVoucher,
    description: productBySku.description,
    properties: !isVoucher ? getSkuProperties(productBySku) : null,
    specs: getSkuSpecs(productBySku),
    skuFeatures,
    skuFeaturesByType,
    SkuByType: skuType,
    partner: {
      name: productBySku.vendor.name,
      logo: productBySku.vendor.logoUrl
    },
    vendorId: productBySku.vendor.id,
    hasPriceUpdated: productBySku.hasPriceUpdated,
    availability: state.availability[productSkuId],
    itemCart,
    onlyCash: productBySku.onlyCash !== null ? productBySku.onlyCash : false
  }
}



// WEBPACK FOOTER //
// ./src/Catalog/Product/ProductDetail/reducer.js